import React, { Component } from "react";
import Profile from "../../views/Profile/Profile";
import { connect } from "react-redux";
import * as userProfileActions from "../../redux/actions/userProfileActions";
import * as userActions from "../../redux/actions/userActions";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { withTranslation } from "react-i18next";
import { enqueueSuccessSnackbar } from "../../redux/actions/snackbarActions";

class LearningCenterProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onProfilePictureApply = this.onProfilePictureApply.bind(this);
  }

  componentDidMount() {
    this.props.userProfileActions.fetchUserProfile();
  }

  onProfilePictureApply(file, successCallback) {
    let uploadingObject = {
      profile_image: file
    };
    this.props.userProfileActions.updateUserProfilePicture(
      uploadingObject,
      this.props.userProfile.userProfile.id,
      () => {
        successCallback();
        this.props.userActions.fetchUser();
        this.props.displaySuccessMessage(
          this.props.t("profile.pictureSavedMsg")
        );
      }
    );
  }

  render() {
    const {
      userProfile: { userProfile, userProfileLoading, updating },
      userActions: { fetchUser },
      userProfileActions: { fetchUserProfile, updateUserProfile },
      displaySuccessMessage
    } = this.props;

    const { t } = this.props;

    const onSave = params => {
      const payload = userProfile;
      payload.settings = { ...payload.settings, ...params.settings };
      updateUserProfile(
        userProfile,
        function() {
          displaySuccessMessage(t("profile.successMsg"));
          fetchUser();
        },
        message => alert(message)
      );
    };

    const onCancel = () => {
      fetchUserProfile();
    };

    if (userProfile && !userProfileLoading && userProfile.id) {
      return (
        <Profile
          userId={userProfile.firstName}
          firstName={userProfile.firstName}
          lastName={userProfile.lastName}
          position={userProfile.position}
          location={userProfile.location}
          phone={userProfile.phone}
          email={userProfile.email}
          hireDate={userProfile.hireDate}
          preferredLanguage={userProfile.settings.preferred_language}
          profilePicture={userProfile.avatar}
          updating={updating}
          onProfilePictureApply={this.onProfilePictureApply}
          onSave={onSave}
          onCancel={onCancel}
        />
      );
    } else {
      return <LoadingSpinner />;
    }
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfileState,
  user: state.userProfileState
});

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch),
  userProfileActions: bindActionCreators(userProfileActions, dispatch),
  displaySuccessMessage: message =>
    dispatch(enqueueSuccessSnackbar({ message }))
});

const TranslatedLearningCenterProfile = withTranslation()(
  LearningCenterProfile
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslatedLearningCenterProfile);

LearningCenterProfile.propTypes = {};
